import { render } from "./Meigaradetail.vue?vue&type=template&id=0fdd3d25"
import script from "./Meigaradetail.vue?vue&type=script&lang=js"
export * from "./Meigaradetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__